import './App.css';
import React, { useState } from 'react';
import { BrowserRouter   } from 'react-router-dom';
import Router from './Router';
import ProfileForms from './component/profile-forms'
import CONFIG from './config';

if (!CONFIG.DEBUG) {
  console.log = function () { }
  console.warn = function () { }
}

const App = () => {
  return (
		<>
    <BrowserRouter>
       <Router />
    </BrowserRouter>
		</>
  );
}


export default App;
